module.exports = __webpack_public_path__ + "static/media/012_iOS - 14 - APPOINTMENTS.38fdb146.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/kp/012_iOS - 14 - APPOINTMENTS.png
// module id = 509
// module chunks = 0